/**
 * @generated SignedSource<<0e4b469a08fa1bcb6e46621ac029d2c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutRelayAction_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaymentReducer_buyer" | "checkoutShippingReducer_buyer" | "checkoutTransactionReducer_buyer">;
  readonly " $fragmentType": "checkoutRelayAction_buyer";
};
export type checkoutRelayAction_buyer$key = {
  readonly " $data"?: checkoutRelayAction_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutRelayAction_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutRelayAction_buyer"
};

(node as any).hash = "f81fdfe322222d0339334ab270c930ad";

export default node;
